import { useSelector } from 'react-redux'

export const useAuth = () => (
  useSelector(state => state.auth)
)

export const useUserInfo = () => (
  useSelector(state => state.auth?.userInfo)
)

export const useBusinessInfo = () => (
  useSelector(state => state.auth?.business)
)

export const useAppSettings = () => (
  useSelector(state => state.auth?.appSettings)
)